/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetJobPositionDto
 */
export interface GetJobPositionDto {
    /**
     * 
     * @type {string}
     * @memberof GetJobPositionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetJobPositionDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetJobPositionDto
     */
    harmfulFactorsIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetJobPositionDto
     */
    active?: boolean | null;
}

/**
 * Check if a given object implements the GetJobPositionDto interface.
 */
export function instanceOfGetJobPositionDto(value: object): value is GetJobPositionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetJobPositionDtoFromJSON(json: any): GetJobPositionDto {
    return GetJobPositionDtoFromJSONTyped(json, false);
}

export function GetJobPositionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobPositionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'harmfulFactorsIds': json['harmfulFactorsIds'] == null ? undefined : json['harmfulFactorsIds'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function GetJobPositionDtoToJSON(value?: GetJobPositionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'harmfulFactorsIds': value['harmfulFactorsIds'],
        'active': value['active'],
    };
}

